import { Component, OnInit } from '@angular/core';
import { OrderHistoryService } from '../order-history.service';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { IOrderItemsDto } from 'src/app/models/backend/order-histories';
import { MatDialogRef } from '@angular/material/dialog';
import { UserRole } from 'src/app/models/enums';

@Component({
  selector: 'app-order-items',
  templateUrl: './order-items.component.html',
  styleUrls: ['./order-items.component.scss']
})
export class OrderItemsComponent implements OnInit{
 
 orderNumber= localStorage.getItem("orderNumber");   
 Items:any
 loader=false
 showOrderDetails:boolean = false;
 constructor(public service:OrderHistoryService,
  public dialogRef: MatDialogRef<OrderItemsComponent>
 
  ){}
  ngOnInit(): void {
    this.loader=true
    this.getItemsbyOrdernumber();
    if(localStorage.getItem("RoleType").toString()==UserRole.Admin.toString()){
      this.showOrderDetails=true;
    }
    else{
      this.showOrderDetails=false;
    }
  }
  getItemsbyOrdernumber()
  {
    this.loader=true
    this.service.getItembyOrderNumber(this.orderNumber).subscribe((res:any)=>
      {
        debugger;
        console.log(res)
        
       this.Items=res.result;
       
      })
      this.loader=false
  }
  closeDialog() {
    this.dialogRef.close({ refresh: false });
  }

}
